module.exports = __webpack_public_path__ + "img/2008.776e7641.png";